import React, {useEffect, useState} from 'react';

import DommusBarraTitulo from "../../components/DommusBarraTitulo";
import ItemBarraTitulo from "../../components/DommusBarraTitulo/ItemBarraTitulo";
import {Row} from "react-bootstrap";
import './style.scss'
import guService from "../../services/guService";
import Swal from "sweetalert2";
import {trackPromise} from "react-promise-tracker";
import CardModulo from "./CardModulo";
import DommusLoading from "../../components/DommusLoading/DommusLoading";

export default function Dashboard(props) {

    const [modulos, setModulos] = useState([]);
    const [listaModulos, setListaModulos] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const newModulos = modulos.map(modulo => {
            const response = modulo;
            if(modulo.modulo_usuario && modulo.modulo_usuario.status && modulo.modulo_usuario.cliente_modulo.status) {
                response.ativo = true;
            } else {
                response.ativo = false;
            }
            return response;
        })

        setListaModulos(newModulos);
    }, [modulos])


    useEffect(() => {
        trackPromise(
          guService.dashboard.todosModulos().then(res => {
              setModulos(res.data);
          }).catch(e => {
              Swal.fire({
                  titleText: "Erro",
                  text: "Houve um problema ao buscar a listagem de módulos " + e,
                  icon: 'error'
              });
          })
        )
    }, []);

    return <>
        <DommusBarraTitulo>
            <ItemBarraTitulo>
                Acesso aos Módulos
            </ItemBarraTitulo>
        </DommusBarraTitulo>
        <Row className="dashboard">
            {listaModulos && modulos.map((modulo, index) => {
                return <CardModulo key={index} modulo={modulo}/>
            })}
        </Row>
        {isLoading && <DommusLoading/>}

    </>
}
